import {
  GET_LABREQUESTREPORTAUX_FAIL,
  GET_LABREQUESTREPORTAUX_SUCCESS,
  GET_LABREQUESTREPORTAUXS_FAIL,
  GET_LABREQUESTREPORTAUXS_SUCCESS,
  ADD_LABREQUESTREPORTAUX_SUCCESS,
  ADD_LABREQUESTREPORTAUX_FAIL,
  UPDATE_LABREQUESTREPORTAUX_SUCCESS,
  UPDATE_LABREQUESTREPORTAUX_FAIL,
  UPDATE_LABREQUESTREPORTAUXCHECK,
  DELETE_LABREQUESTREPORTAUX_SUCCESS,
  DELETE_LABREQUESTREPORTAUX_FAIL,  
  SET_STATE_LABREQUESTREPORTAUX
} from "./actionTypes";

const INIT_STATE = {
  labRequestReportAuxs: [],
  labRequestReportAux: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestReportAuxs = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTREPORTAUXS_SUCCESS:
      return {
        ...state,
        labRequestReportAuxs: action.payload.labRequestReportAuxs,
        labRequestReportAuxs: action.payload.labRequestReportAuxs.map(labRequestReportAux => {
          return {...labRequestReportAux, /*checked: false*/ }
        }),
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTREPORTAUX:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTREPORTAUXS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTREPORTAUX_SUCCESS:
      return {
        ...state,
        labRequestReportAuxs: [...state.labRequestReportAuxs, action.payload],
      };

    case ADD_LABREQUESTREPORTAUX_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTREPORTAUX_SUCCESS:
      return {
        ...state,
        labRequestReportAuxs: state.labRequestReportAuxs.map(labRequestReportAux =>
          labRequestReportAux.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestReportAux }
            : labRequestReportAux
        ),
      };

    case UPDATE_LABREQUESTREPORTAUXCHECK:
      return {
        ...state,
        labRequestReportAuxs: state.labRequestReportAuxs.map(labRequestReportAux =>
          labRequestReportAux.id.toString() === action.payload.id.toString()
            ? { ...labRequestReportAux, /*checked: action.payload.checked */ }
            : labRequestReportAux
        ),
      };

    case UPDATE_LABREQUESTREPORTAUX_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTREPORTAUX_SUCCESS:
      return {
        ...state,
        labRequestReportAuxs: state.labRequestReportAuxs.filter(
          labRequestReportAux => labRequestReportAux.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTREPORTAUX_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTREPORTAUX_SUCCESS:
      return {
        ...state,
        labRequestReportAux: action.payload,
      };

    case GET_LABREQUESTREPORTAUX_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestReportAuxs;
